import React, {useEffect} from 'react';
import {Styles} from '../../../../config/design/styles';
import { withStyles } from '@mui/styles';
import {useTranslation} from "react-i18next";
import {connect} from "trim-redux";
import axios from "axios";
import {useLocation} from "react-router-dom";
import {defaultVariables} from "../../../../config";
import { requestPermission } from "../../../../firebase";

const PATHS_SKIP_FCM_PROMPT = ['/login', '/email-login', '/register', '/reset-password'];

function UpdateLiveLocation({user,isAuth,setting}){
    const { t } = useTranslation();
    const { pathname } = useLocation();

    useEffect(() => {
        if (!isAuth || !user?.id) {
            return;
        }
        const skipFcm =
            PATHS_SKIP_FCM_PROMPT.some((p) => pathname === p || pathname.startsWith(`${p}/`));
        if (skipFcm) {
            return;
        }
        if (user.role?.name === "transport") {
            updateLiveLocation();
        }
        try {
            requestPermission().then((token) => {
                if (token) {
                    sendTokenToServer(token);
                }
            });
        } catch (error) {
            //console.error("Error sending location:", error);
        }
    }, [isAuth, user, pathname]);
    const updateLiveLocation = () => {
        const loginToken = localStorage.getItem('ACT');
        const config = {
            headers: {
                Accept: 'application/json',
                Authorization: `Bearer ${loginToken}`
            }
        };
        const sendLocation = async () => {
            if (navigator.geolocation) {
                navigator.geolocation.getCurrentPosition(
                    async (position) => {
                        const { latitude, longitude } = position.coords;
                        try {
                            await axios.post(`${defaultVariables.url}/couriers/update-location`, { latitude, longitude },config);
                            //console.log("Location sent:", latitude, longitude);
                        } catch (error) {
                            //console.error("Error sending location:", error);
                        }
                    },
                    (error) => {
                        console.error("Error getting location:", error);
                    }
                );
            } else {
                console.error("Geolocation is not supported by this browser.");
            }
        };

        // Send location immediately
        sendLocation();

        // Set interval to send location every 2 minutes
        const interval = setInterval(sendLocation, setting.live_location_update * 60 * 1000);

        return () => clearInterval(interval);
    };
    const sendTokenToServer = async (token) => {
        const loginToken = localStorage.getItem('ACT');
        if (!loginToken) {
            return;
        }
        const config = {
            headers: {
                Accept: 'application/json',
                Authorization: `Bearer ${loginToken}`,
            },
        };
        try {
            await axios.post(`${defaultVariables.url}/firebase/save-token`, { token }, config);
        } catch (e) {
            /* Oturum henüz hazır değil, token süresi dolmuş veya Sanctum reddi — uygulamayı düşürme */
            if (process.env.NODE_ENV === 'development' && e.response?.status && e.response.status !== 401) {
                console.warn('firebase/save-token', e.response.status);
            }
        }
    };
    return (
        <>

        </>

    );
}
const mapStateToProps = (state) => ({
    setting: state.setting,
    user: state.user,
    isAuth: state.isAuth,
});

export default withStyles(Styles)(connect(mapStateToProps)(UpdateLiveLocation));
